import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { load, isLoading } from '../reducers/teamForm';
import FootballMatchTeamsForm from '../components/FootballMatchTeamsForm';

@standardAsyncConnect([
  {
    dispatch: ({params: {matchId}}) => load(matchId),
    preventResolve: ({state, params: {matchId}}) => isLoading(state, matchId),
    state: (state, props) => ({teamForm: state.football.teamForm[props.params.matchId].form})
  }
])
@catchLifeCycleErrors
export default class FootballMatchFormContainer extends Component {
  static propTypes = {
    matchLabel: PropTypes.string,
    teamForm: PropTypes.object,
    params: PropTypes.object
  }

  render() {
    return (
      <FootballMatchTeamsForm teamsForm={this.props.teamForm} matchLabel={this.props.matchLabel}/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballMatchFormContainer.js